/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type SalesforceCasesConfigureEmailsController from 'embercom/controllers/apps/app/standalone/deploy/salesforce/cases/configure-emails';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type RouterService from '@ember/routing/router-service';

export default class ConfigureEmails extends Route {
  @service declare appService: $TSFixMe;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;

  queryParams = {
    section: {
      refreshModel: false,
    },
  };

  async beforeModel() {
    if (!this.appService.app.canAccessSalesforceCasesRedesign) {
      this.router.transitionTo('apps.app.standalone.deploy.salesforce.cases');
    }
  }

  setupController(
    controller: SalesforceCasesConfigureEmailsController,
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    let params = this.paramsFor(this.routeName) as { section: string };

    if (params.section) {
      controller.set('section', params.section);
    } else {
      controller.set('section', this.openSectionId);
    }
  }

  resetController(
    controller: SalesforceCasesConfigureEmailsController,
    isExiting: boolean,
    transition: Transition,
  ) {
    super.resetController(controller, isExiting, transition);
    if (isExiting) {
      controller.set('section', null);
    }
  }

  get salesforceConfig() {
    return this.finStandaloneService.salesforceConfig!;
  }

  get openSectionId() {
    return null;
  }
}
